// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { calendarArrowsRotateReverseDot16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-calendar-arrows-rotate-reverse-dot': IconCalendarArrowsRotateReverseDot;
    }
}

/**
 * The icon component for the 'calendarArrowsRotateReverseDot' icon
 */
export class IconCalendarArrowsRotateReverseDot extends IconSvg {
    public constructor() {
        super(calendarArrowsRotateReverseDot16X16);
    }
}

registerIconSvg('icon-calendar-arrows-rotate-reverse-dot', IconCalendarArrowsRotateReverseDot);
export const iconCalendarArrowsRotateReverseDotTag = 'nimble-icon-calendar-arrows-rotate-reverse-dot';
